import {
	Pipe,
	PipeTransform,
} from '@angular/core';
import { commonUtilitiesCoreService } from '../services/core.service';

@Pipe({
	name: 'commonExtensionFormatter',
})
export class CommonExtensionFormatterPipe implements PipeTransform {
	transform (extension: string): string {
		if (!commonUtilitiesCoreService.hasValue(extension)) {
			return extension;
		}

		return extension.substring(1).toLowerCase();
	}
}
